import React from 'react';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, InputAdornment, MenuItem, Radio, RadioGroup, Switch, TextField } from '@mui/material';

const QTCurrentForm = props => (
    <div>
        <h5 style={{marginBottom: '2vh'}}>Current measurement details</h5>

        <TextField
            fullWidth
            label="Voltage"
            value={props.voltage}
            onChange={event => props.setVoltage(event.target.value)}
            error={props.voltageError !== ''}
            helperText={props.voltageError}
            InputProps={{endAdornment: <InputAdornment position="end">V</InputAdornment>}}
            style={{marginBottom: '2vh'}}
        />

        <TextField
            fullWidth
            label="Assumed power factor"
            value={props.powerFactor}
            onChange={event => props.setPowerFactor(event.target.value)}
            error={props.powerFactorError !== ''}
            helperText={props.powerFactorError}
            style={{marginBottom: '2vh'}}
        />

        <FormControl error={props.phaseTypeError !== ''} style={{marginBottom: '2vh'}}>
            <FormLabel>Phase type</FormLabel>
            <RadioGroup row value={props.phaseType} onChange={event => props.setPhaseType(event.target.value)}>
                <FormControlLabel value="1-phase" control={<Radio />} label="Single phase" />
                <FormControlLabel value="3-phase" control={<Radio />} label="Three phase" />
            </RadioGroup>
            {props.phaseTypeError !== '' && <FormHelperText>{props.phaseTypeError}</FormHelperText>}
        </FormControl>

        {props.showChannelCount && <TextField
            select
            fullWidth
            label="CT channels"
            value={props.channelCount}
            onChange={event => props.setChannelCount(event.target.value)}
            helperText="Choose whether this Milesight CT reports one or three readings per timestamp."
            style={{marginBottom: '2vh'}}
        >
            <MenuItem value="1">1 channel</MenuItem>
            <MenuItem value="3">3 channels</MenuItem>
        </TextField>}

        <FormControlLabel
            control={<Switch checked={props.hasVfd} onChange={event => props.setHasVfd(event.target.checked)} />}
            label="Variable-frequency drive (VFD)"
        />
    </div>
);

export default QTCurrentForm;
